import { supabase } from '../lib/supabase';

export interface ProvinciaEclesiastica {
  id: string;
  nombre: string;
  codigo_iso: string;
  continente?: string | null;
  activo: boolean;
  created_at: string;
}

export const provinciaEclesiasticaService = {
  async listarActivos(): Promise<ProvinciaEclesiastica[]> {
    const { data, error } = await supabase
      .from('provincias_eclesiasticas')
      .select('*')
      .eq('activo', true)
      .order('nombre', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  async listarTodos(): Promise<ProvinciaEclesiastica[]> {
    const { data, error } = await supabase
      .from('provincias_eclesiasticas')
      .select('*')
      .order('nombre', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  async getAll(): Promise<ProvinciaEclesiastica[]> {
    return this.listarTodos();
  },

  async obtenerPorId(id: string): Promise<ProvinciaEclesiastica | null> {
    const { data, error } = await supabase
      .from('provincias_eclesiasticas')
      .select('*')
      .eq('id', id)
      .maybeSingle();

    if (error) throw error;
    return data;
  },

  async crear(provinciaEclesiastica: Omit<ProvinciaEclesiastica, 'id' | 'created_at'>): Promise<ProvinciaEclesiastica> {
    const { data, error } = await supabase
      .from('provincias_eclesiasticas')
      .insert(provinciaEclesiastica)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async actualizar(id: string, provinciaEclesiastica: Partial<Omit<ProvinciaEclesiastica, 'id' | 'created_at'>>): Promise<ProvinciaEclesiastica> {
    const { data, error } = await supabase
      .from('provincias_eclesiasticas')
      .update(provinciaEclesiastica)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async eliminar(id: string): Promise<void> {
    const { error } = await supabase
      .from('provincias_eclesiasticas')
      .delete()
      .eq('id', id);

    if (error) throw error;
  },

  async desactivar(id: string): Promise<ProvinciaEclesiastica> {
    return this.actualizar(id, { activo: false });
  },

  async activar(id: string): Promise<ProvinciaEclesiastica> {
    return this.actualizar(id, { activo: true });
  }
};
